module.exports = {
      id: "breaking-news-usage",
      viewBox: "0 0 25 25",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#breaking-news",
      toString: function () {
        return this.url;
      }
    }